const isSameOrigin = (window: Window, url: string): boolean => {
  try {
    return (
      window.location.origin === new URL(url, window.location.origin).origin
    );
  } catch {
    return false;
  }
};

export { isSameOrigin };
